export default class extends Controller {
  static targets = ['checkbox', 'select'];

  connect() {
    this.isChecked = this.checkboxTarget.checked;
    this.isChecked && this.showSelect();
  }

  toggleSelect() {
    this.isChecked = !this.isChecked;
    this.isChecked ? this.showSelect() : this.hideSelect();
  }

  showSelect() {
    this.selectTarget.style.display = 'block';
  }

  hideSelect() {
    this.selectTarget.style.display = 'none';
  }

  get isChecked() {
    return this._isChecked;
  }

  set isChecked(val) {
    this._isChecked = val;
  }
}



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/projects/retainer-checkbox-controller.js